// extracted by mini-css-extract-plugin
export var label = "_cc-1";
export var reminder = "_cc-0";